import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import SparkApi from "../../api/SparkApi";
import { ShimmerTable } from "react-shimmer-effects";
import InfoPill from "../InfoPill";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { Link } from "react-router-dom";
import RackCreate from "./RackCreate";
import { toast, ToastContainer } from "react-toastify";
import JsBarcode from "jsbarcode";
import { FaDownload } from "react-icons/fa";
import { usePermission } from "../context/PermissionContext";

const RackList = () => {
  const [body, setBody] = useState();
  const [createShowModal, setCreateShowModal] = useState(false);
  const { permissionData , userInfo } = usePermission();
  const can_create = permissionData?.Rack?.can_create;

  useEffect(() => {
    fetchRacksData();
  }, []);

  //------------------barcode download start------------------------------------
  const BarcodeCell = ({ id, value }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
      if (canvasRef.current) {
        JsBarcode(canvasRef.current, value, {
          width: 1,
          height: 30,
          displayValue: true,
        });
      }
    }, [value]);

    const handleBarcodeDownload = () => {
      if (canvasRef.current) {
        const imageUrl = canvasRef.current.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = imageUrl;
        link.download = `barcode-${id}.png`;
        link.click();
      }
    };

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <canvas ref={canvasRef} />
        <FaDownload
          size={16}
          style={{ cursor: "pointer", color: "#007bff" }}
          onClick={handleBarcodeDownload}
          title="Download Barcode"
        />
      </div>
    );
  };
  //------------------barcode download end------------------------------------

  async function fetchRacksData() {
    try {
      const result = await SparkApi.fetchRacks();
      if (result.success) {
        setBody(result.data);
      } else {
        setBody([]);
      }
    } catch (error) {
      toast.error("Internal server error")
    }
  }

  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const header = [];
  header.push(
    {
      title: "Name",
      prop: "name",
      isFilterable: true,
      isSortable:true,
      cell: (row) => (
        <Link to={"/rack/" + row.id} state={row}>
          {capitalizeWords(row.name)}
        </Link>
      ),
    },
    { title: "Warehouse Name", prop: "warehouse_name", isFilterable: true, isSortable:true, },
    {
      title: "Barcode",
      prop: "barcode",
      cell: (row) => <BarcodeCell id={row.id} value={row.barcode} />,
    },
    { title: "Description", prop: "description", isFilterable: true },
    { title: "Status",
      prop: "status",
      isFilterable: true,
      isSortable:true ,
      cell : (row) => (
        <span 
          className={`badge px-3 py-2 text-white ${row?.status === 'Active' ? 'bg-success' : 'bg-danger'}`}
          style={{ minWidth: "80px", textAlign: "center" }}
        >
          {row?.status === 'Active' ? 'Active' : 'InActive'}
        </span>
      ),
     }
  );

  const labels = {
    beforeSelect: " ",
  };

  const createRack = () => {
    setCreateShowModal(true);
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {createShowModal && (
        <RackCreate
          show={createShowModal}
          onHide={() => setCreateShowModal(false)}
          fetchRacks={fetchRacksData}
        />
      )}

      <Container>
        <Row className="g-0">
          <Col lg={12}>
            {body ? (
              <DatatableWrapper
                body={body}
                headers={header}
                paginationOptionsProps={{
                  initialState: {
                    rowsPerPage: 10,
                    options: [5, 10, 15, 20],
                  },
                }}
              >
                <Row className="mb-4">
                  <Col xs={12} lg={4} sm={4} className="d-flex flex-col justify-content-end align-items-end">
                    <Filter />
                  </Col>
                  <Col xs={9} sm={6} lg={4} className="d-flex flex-col justify-content-start align-items-start">
                    <PaginationOptions labels={labels} />
                    <div className="mt-2">
                      <InfoPill
                        className="d-flex flex-col justify-content-start align-items-start"
                        left="Total Rack"
                        right={body ? body.length : 0}
                        style={{ marginTop: "20px" }}
                      />
                    </div>
                  </Col>
                  <Col xs={3} sm={2} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                    {(userInfo?.userrole === "ADMIN" || can_create) && 
                      (<Button
                        className="btn-sm custom-btn-css-add-new-record px-1 d-flex flex-col justify-content-end align-items-end"
                        variant="outline-primary"
                        onClick={() => createRack(true)}
                      >
                        New Rack
                      </Button>
                    )}
                  </Col>
                </Row>
                <Table striped className="data-table rack-list" responsive="sm">
                  <TableHeader />
                  <TableBody />
                </Table>
                <Pagination />
              </DatatableWrapper>
            ) : (
              <ShimmerTable row={10} col={8} />
            )}
          </Col>
          <Col lg={2}></Col>
        </Row>
      </Container>
    </>
  );
};

export default RackList;
